var map = {
	"./bigquery.png": 3469,
	"./canva.png": 2894,
	"./css.png": 3054,
	"./download.png": 5763,
	"./excel.png": 5098,
	"./firebase.png": 6624,
	"./git.png": 4883,
	"./html.png": 6964,
	"./javascript.png": 1010,
	"./jupyter.png": 6592,
	"./libreoffice.png": 2321,
	"./linux.png": 1849,
	"./lookerstudio.png": 265,
	"./mssqlserver.png": 2213,
	"./notion.png": 4784,
	"./office365.png": 2571,
	"./powerbi.png": 7427,
	"./powerpoint.png": 8988,
	"./python.png": 7125,
	"./r.svg": 9907,
	"./react.png": 7398,
	"./sheets.png": 9379,
	"./tableau.png": 5417,
	"./troubleshooting.png": 9609,
	"./vue.png": 7339,
	"./web-scraping.png": 3922,
	"./workspace.png": 7300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1747;